/**
 * 功能: 侧边按钮组件, 展示目录、图表目录和报告日志, 点击目录或者图表目录可以跳转到文章对应的位置
 */
<template lang="pug">
  .appendix-tree
    .right-panel
      div.handle-button(:style="{'top': 45 + 'vh','background-color': '#409EFF'}"
        @click="isshow" :class="show ? 'show-aside' : 'not-show-aside'")
        i(:class="show ?'el-icon-close':'el-icon-tickets'")
    div(style="border:1px solid #ccc")
      el-tabs(:stretch="true" type="border-card")
        el-tab-pane(label="文章目录" )
          el-tree(class="filter-tree"  :data="menuList" node-key="_id" :default-expand-all="true"  :highlight-current="true" :expand-on-click-node="false"
            @node-click="handleNodeClick" )
              span.custom-tree-node(slot-scope="{node,data}" class="span-ellipsis" :title="data.name") {{data.wbs}} {{data.name}}
        el-tab-pane(label="图表目录" )
          div(v-for="attchment in list" style="border-bottom: 1px solid #ccc")
            label(:key="attchment.subObject" @click="handleClick(attchment)" v-if="attchment._class === 0")
              h4(style="padding: 10px 0 0 10px") {{attchment.explain}} {{attchment.title || ''}}
              div(style="width:100%; height: 180px;padding: 10px")
                img(:src="attchment.newhiImageUrl" style="width:100%; height:100%; object-fit:contain;")

            label(:key="attchment.subObject" @click="handleClick(attchment)" v-if="attchment._class === 1")
              h4(style="padding: 10px 0 0 10px") {{attchment.explain}} {{attchment.title || ''}}
              div(style="padding: 10px")
                div.tablelook.previewtableLook(v-html="attchment.html" style="width:100%;")

            label(:key="attchment.subObject" @click="handleClick(attchment)" v-if="attchment._class === 2")
              h4(style="padding: 10px 0 0 10px") {{attchment.explain}} {{attchment.title || ''}}
              div(style="width:100%;")
                drawSziePro(:dialogData="attchment" style='width:100%;' :isActive="false")
        el-tab-pane(label="报告日志" )
          div(v-for="(log,index) in updateLog" :key="index")
            div(style='margin-bottom:10px')
              p 作者:{{ log.author }}
              p 发布日期:{{ log.pubDate | changeData }}
              p 描述:{{ log.description }}
</template>

<script>
import drawSziePro from '@/views/size/components/drawsizePro'
import { parseTime } from '@/javascripts/time'

export default {
  name: 'right',
  components: { drawSziePro },

  data () {
    return {
      show: false,
      activeName: 'first'
    }
  },
  props: ['menuList', 'list', 'updateLog'],
  methods: {
    isshow () {
      this.show = !this.show
      this.$emit('showAside', this.show)
    },
    // 跳转章节目录对应的位置
    handleNodeClick (data, node, self) {
      document.querySelector('#a' + data._id).scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    // 跳转图表目录对应的位置
    handleClick (item) {
      document.querySelector('#p' + item._id).scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  },

  filters: {
    changeData: function (val) {
      if (!val) return '暂无日期'
      return parseTime(new Date(val), '{y}-{m}-{d}')
    }
  }
}
</script>
<style>

.previewtableLook table {
  transform: scale(0.8,0.8);
}

.appendix-tree .el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

.appendix-tree .el-tabs__content {
  height: calc(100vh - 100px);
  overflow-y: auto !important;
}

</style>
<style lang="scss" scoped>
.right-panel {
  width: 100%;
  max-width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}

.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  cursor: pointer;
  pointer-events: auto;
  color: #fff;
  line-height: 48px;

  i {
    font-size: 24px;
    line-height: 48px;
  }
}

.not-show-aside {
  left: -48px;
}

.show-aside {
  left: -400px;
}

.filter-tree{font-size: 16px;height:85vh;overflow:auto;padding: 0 10px}

.span-ellipsis{width: 100%;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;margin:0 0 7px 0;color: #666666}

.span-ellipsis {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.glossary {
  text-indent: 2em;
  margin: 0 0 10px;
}

</style>
